export default "<!-- <div class=\"container\" style=\"margin-top: 78px;\">\r\n\r\n</div> -->\r\n\r\n<router-outlet></router-outlet>\r\n"